export default "/img/AL.17f35cbe986a7eba5a72fa6bfff28682.png";